import Phaser from 'phaser';
import Player, { preload as preloadPlayer } from '../../objects/test/Player';
import { preload as preloadAudio } from '../../objects/test/Audio';

/** @see https://freesfx.co.uk/ */
export default class PlayerObject extends Phaser.Scene {
  constructor() {
    super({ key: 'PlayerObject', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadPlayer.call(this);
    preloadAudio.call(this, 'music', 'music.mp3');
    preloadAudio.call(this, 'close_wood', 'close_wood.mp3');
    preloadAudio.call(this, 'knock', 'knock.mp3');
    preloadAudio.call(this, 'poof', 'poof.mp3');
  }

  create() {
    this.physics.world.setBoundsCollision(true);
    
    this.audio = {
      background: this.sound.add('music', {
        volume: 0.5,
        loop: true,
      }),
      close_wood: this.sound.add('close_wood', {
        volume: 0.8,
      }),
      knock: this.sound.add('knock'),
      poof: this.sound.add('poof'),
    };

    this.player = new Player({
      scene: this,
      x: this.game.config.width / 2,
      y: this.game.config.height / 2,
    });

    this.audio.background.play();

    this.tweens.timeline({
      targets: this.player,
      tweens: [
        {
          alpha: 1,
          onStart: () => {
            this.player.move();
          },
          duration: 1000,
        },
        {
          alpha: 1,
          onStart: () => {
            this.audio.poof.play();
          },
          offset: '-=500',
          duration: 0,
        },
        {
          alpha: 1,
          onStart: () => {
            this.player.stop();
          },
          duration: 1000,
        },
        {
          alpha: 1,
          onStart: () => {
            this.player.move({
              direction: 'left',
            });
          },
          duration: 1000,
        },
        {
          alpha: 1,
          onStart: () => {
            this.player.stop();
            this.audio.knock.play();
          },
          duration: 190,
        },
        {
          alpha: 1,
          onStart: () => {
            this.audio.knock.play();
          },
          duration: 230,
        },
        {
          alpha: 1,
          onStart: () => {
            this.audio.knock.play();
          },
          duration: 200,
        }
      ]
    });
  }
}
